<template>
  <div>
    <div id="lineApex"></div>
  </div>
</template>
<script>
export default {
  name: "LineApex",
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  methods:{
    initChart(){
      var options = {
          series: [{
            name: "Clicks Count",
            data: [1000, 1100, 1300, 1405, 1300, 1500, 1700, 1800, 1900]
        }],
          chart: {
          height: 350,
          type: 'line',
          zoom: {
            enabled: false
          },
          toolbar: {
            show: false
          },
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth'
        },
        title: {
          text: '',
          align: 'left'
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5
          },
        },
        xaxis: {
          categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep'],
        }
        };

        var chart = new ApexCharts(document.querySelector("#lineApex"), options);
        chart.render();
    }
  }
};
</script>
